import { Component, OnInit, Inject } from '@angular/core';
import {EntityRawMaterialsDtoExtended} from '@root/user/src/app/view/neq/pages/rawmaterials/rawmaterials-list.page';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'neq-rawmaterials-export-dialog',
  templateUrl: './rawmaterials-export-dialog.component.html'
})
export class RawmaterialsExportDialogComponent implements OnInit {

  message: string;
  entities: EntityRawMaterialsDtoExtended[];
  defaultFormat: string;
  listFormat: string[];
  selectedValue: string[];

  constructor(
    private readonly dialogRef: MatDialogRef<RawmaterialsExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      message: string,
      rawMaterials: EntityRawMaterialsDtoExtended[],
      defaultFormat: string,
      listFormat: string
    }
  ) {
  }

  ngOnInit(): void {
    if (this.data) {
      if (this.data.message) {
        this.message = this.data.message;
      }
      if (this.data.rawMaterials) {
        this.entities = this.data.rawMaterials;
      }
      if (this.data.defaultFormat) {
        this.defaultFormat = this.data.defaultFormat;
        this.selectedValue = [this.defaultFormat];
      }
      if (this.data.listFormat) {
        this.listFormat = this.data.listFormat.split(';');
      }
    }
  }

  continue() {
    this.dialogRef.close(this.selectedValue);
  }

  goBack() {
    this.dialogRef.close(false);
  }
}
